import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { validateEquipmentForm } from "../Datas";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  workoutEquipmentsAdd,
  workoutEquipmentsUpdate,
} from "../../../data/ApiEndpoints";

const AddEquipmentForm = ({
  closeModal,
  callFunction,
  userInfoData,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    equipmentName: isEdit ? rowData?.name : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateEquipmentForm(formValues));
    setIsSubmit(true);
  };

  const handleAddLead = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? workoutEquipmentsUpdate : workoutEquipmentsAdd;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.equipmentName,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAddLead(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        `${isEdit ? "Update" : "Add"} Equipment`
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Equipment`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="equipmentName" className={`formInputLabel `}>
              Equipment name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Equipment name"
              className={`formInput ${
                formErrors?.equipmentName ? "formError" : ""
              }`}
              name="equipmentName"
              value={formValues.equipmentName}
              onChange={onChangeInput}
            />
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddEquipmentForm;
